import { Button, ClickEvent, SaveButton, Snackbar } from "@mcleod/components";
import { Api, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutZipCodeGenerator } from "./autogen/AutogenLayoutZipCodeGenerator";
import { CommonDialogs } from "@mcleod/common";

export class ZipCodeGenerator extends AutogenLayoutZipCodeGenerator {

    private _saveButton: SaveButton;
    private _regUid: number;
    private _modelRows: ModelRow [];

    public set saveButton(value: SaveButton) { this._saveButton = value; }
    public get saveButton() { return this._saveButton; }
    public set regUid(value: number) { this._regUid = value; }
    public get regUid() { return this._regUid; }
    public set modelRows(value: ModelRow []){ this._modelRows = value; }
    public get modelRows() {return this._modelRows; }

    async buttonGenerateZipsOnClick(event: ClickEvent) {
        const generateButton = event.target as Button;
        if (!this.validateLayout()) return;
        generateButton.busy = true;
        try {
            const response = await Api.post("lme/dispatch/zip-code-generator", {
                reg_uid: this.regUid,
                state_id: this.textboxStateId.text,
                starting_digits: this.textboxStarting3Digits.text,
                ending_digits: this.textboxEnding3Digits.text,
                effective_date: this.textboxEffectiveTimestamp.text,
                expire_date: this.textboxExpireTimestamp.text,
                rxz_type_code: "REV"
            });
            const responseData = response.data[0];
            if (StringUtil.isEmptyString(responseData?.message)) {
                const regXZips = responseData?.reg_x_zips || [];
                this.saveButton.enabled = regXZips.length > 0;
                const modelRows: ModelRow[] = regXZips.map((row: Partial<ModelRow>) => new ModelRow("lme/dispatch/tariff-region-zip", true, row));
                this.tableGeneratedZipCodes.data = modelRows;
                this.modelRows = modelRows;
                this.tableGeneratedZipCodes.displayData(null, modelRows, 0);
                Snackbar.showSnackbar(`Found ${modelRows.length} zip code(s) to apply to this region.`, { millisUntilDismissal: 10000 });
                this.setComponentsEnabled(true);
                generateButton.enabled = false;
            } else {
                Snackbar.showSnackbar(responseData.message);
            }
        } catch (error) {
            CommonDialogs.showError("An error occurred while generating zip codes.");
        } finally {
            generateButton.busy = false;
        }
    }

    buttonClearOnClick(event: ClickEvent) {
        this.saveButton.enabled = false;
        this.setComponentsEnabled(false);
        this.resetData();
    }

    resetData() {
        this.tableGeneratedZipCodes.data = [];
        const modelRows = this.modelRows = [];
        this.tableGeneratedZipCodes.displayData(null, modelRows, 0);
        this.textboxStateId.text = null;
        this.textboxStateId["lookupModelData"] = null;
        this.textboxStarting3Digits.text = null;
        this.textboxEnding3Digits.text = null;
        this.textboxEffectiveTimestamp.text = null;
        this.textboxExpireTimestamp.text = null;
    }

    setComponentsEnabled(fromZipCodeButton: boolean) {
        this.buttonClear.enabled = fromZipCodeButton;
        this.textboxStateId.enabled = !fromZipCodeButton;
        this.textboxStarting3Digits.enabled = !fromZipCodeButton;
        this.textboxEnding3Digits.enabled = !fromZipCodeButton;
        this.textboxEffectiveTimestamp.enabled = !fromZipCodeButton;
        this.textboxExpireTimestamp.enabled = !fromZipCodeButton;
        this.buttonGenerateZips.enabled = !fromZipCodeButton;
    }

    private validateLayout(): boolean {
        const {textboxEffectiveTimestamp,textboxStateId,textboxStarting3Digits,textboxEnding3Digits} = this;

        const startZip = textboxStarting3Digits.text;
        const endZip = textboxEnding3Digits.text;
        const isStartEmpty = StringUtil.isEmptyString(startZip);
        const isEndEmpty = StringUtil.isEmptyString(endZip);

        if (StringUtil.isEmptyString(textboxStateId.text)) {
            Snackbar.showWarningSnackbar("Please provide a valid State ID.");
            return false;
        }

        if (isStartEmpty || isEndEmpty) {
            Snackbar.showWarningSnackbar("Please enter both the starting and ending Zip Codes.");
            return false;
        }

        if ((!isStartEmpty && startZip.length !== 3) || (!isEndEmpty && endZip.length !== 3)) {
            Snackbar.showWarningSnackbar("Starting and Ending Digits must be exactly 3 digits.");
            return false;
        }

        if (StringUtil.isEmptyString(textboxEffectiveTimestamp.text)) {
            Snackbar.showWarningSnackbar("Please enter an effective date.");
            return false;
        }



        return true;
    }

}
